import RootPortals from './components/RootPortals'

export default function () {
  return { component: RootPortals }
}
